import { render, staticRenderFns } from "./PublicRecordDialog.vue?vue&type=template&id=4571db3c&scoped=true"
import script from "./PublicRecordDialog.vue?vue&type=script&lang=js"
export * from "./PublicRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./PublicRecordDialog.vue?vue&type=style&index=0&id=4571db3c&prod&lang=css"
import style1 from "./PublicRecordDialog.vue?vue&type=style&index=1&id=4571db3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4571db3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBtn,VCard,VDialog,VIcon,VImg})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Touch from 'vuetify/lib/directives/touch'
installDirectives(component, {Touch})
